import invariant from 'invariant'
import { conformsTo, isFunction, isObject } from 'lodash'

export default function checkStore(store) {
  const shape = {
    dispatch: isFunction,
    subscribe: isFunction,
    getState: isFunction,
    replaceReducer: isFunction,
    asyncReducers: isObject,
    runSaga: isFunction,
    injectedSaga: isObject
  }
  invariant(
    conformsTo(store, shape),
    '((app/src/stores...) injectors: Expected a valid redux store'
  )
}
